module.exports = __webpack_public_path__ + "img/checked1.d12f9003.png";